// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__1b9pj","card":"Modal_card__3mrws"};